import "../../App.css";
import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import SuggestionWord from "../SuggestionWord";
import axios from "axios";
import nouns from "../../text-files/prompt-nouns.txt";
import verbs from "../../text-files/prompt-verbs.txt";
import adjectives from "../../text-files/prompt-adjectives.txt";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import shuffleIcon from "../../images/shuffle.png";

// Component for prompt suggestions, displayed on the AI Art expedition page

class PromptSuggestions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nounsList: [],
      adjectivesList: [],
      verbsList: [],
    };
  }

  componentDidMount() {
    this.fetchNouns();
    this.fetchAdjectives();
    this.fetchVerbs();
  }

  fetchNouns = () => {
    axios
      .get(nouns)
      .then((response) => {
        const nounsFile = response.data.split("\n");
        const nounsList = nounsFile
          .slice(0, 10)
          .map(() => this.getRandomNoun(nounsFile));
        this.setState({ nounsList });
      })
      .catch((error) => console.error(error));
  };

  getRandomNoun = (nounList) => {
    const randomWord = nounList[Math.floor(Math.random() * nounList.length)];
    return randomWord;
  };

  fetchAdjectives = () => {
    axios
      .get(adjectives)
      .then((response) => {
        const adjectivesFile = response.data.split("\n");
        const adjectivesList = adjectivesFile
          .slice(0, 10)
          .map(() => this.getRandomNoun(adjectivesFile));
        this.setState({ adjectivesList });
      })
      .catch((error) => console.error(error));
  };

  getRandomAdjective = (adjectiveList) => {
    const randomWord =
      adjectiveList[Math.floor(Math.random() * adjectiveList.length)];
    return randomWord;
  };

  fetchVerbs = () => {
    axios
      .get(verbs)
      .then((response) => {
        const verbsFile = response.data.split("\n");
        const verbsList = verbsFile
          .slice(0, 10)
          .map(() => this.getRandomNoun(verbsFile));
        this.setState({ verbsList });
      })
      .catch((error) => console.error(error));
  };

  getRandomVerb = (verbList) => {
    const randomWord = verbList[Math.floor(Math.random() * verbList.length)];
    return randomWord;
  };

  render() {
    const { nounsList } = this.state;
    const suggestionNouns = nounsList.map((word) => (
      <SuggestionWord key={word}>{word}</SuggestionWord>
    ));

    const { adjectivesList } = this.state;
    const suggestionAdjectives = adjectivesList.map((word) => (
      <SuggestionWord key={word}>{word}</SuggestionWord>
    ));

    const { verbsList } = this.state;
    const suggestionVerbs = verbsList.map((word) => (
      <SuggestionWord key={word}>{word}</SuggestionWord>
    ));

    return (
      <Card style={{ height: 600 }}>
        <Card.Header className="light-purple white-text">
          <span>
            Prompt Suggestions
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="tooltip-disabled">
                  Add these useful words to help create images!
                </Tooltip>
              }
            >
              <span style={{ marginLeft: "0.5vw" }}>ⓘ</span>
            </OverlayTrigger>
          </span>
        </Card.Header>
        <Card.Body style={{ alignItems: "left", overflow: "auto" }}>
          <Container>
            {/* Noun suggestions */}
            <Row className="text-left">
              <Card.Title>
                Nouns:
                <Button
                  className="yellow"
                  onClick={this.fetchNouns}
                  style={{ marginLeft: "30%", width: "3rem" }}
                >
                  <img
                    src={shuffleIcon}
                    alt="Refresh"
                    style={{ height: "100%", width: "100%" }}
                  />
                </Button>
              </Card.Title>
            </Row>
            <Row className="text-left">
              <Col className="mb-3">{suggestionNouns}</Col>
            </Row>
            {/* Verb suggestions */}
            <Row className="text-left d-flex align-items-center">
              <Card.Title className="mr-3">
                Verbs:
                <Button
                  className="yellow"
                  onClick={this.fetchVerbs}
                  style={{ marginLeft: "30%", width: "3rem" }}
                >
                  <img
                    src={shuffleIcon}
                    alt="Refresh"
                    style={{ height: "100%", width: "100%" }}
                  />
                </Button>
              </Card.Title>
            </Row>
            <Row className="text-left">
              <Col className="mb-3">{suggestionVerbs}</Col>
            </Row>
            {/* Adjective suggestions */}
            <Row className="text-left d-flex align-items-center">
              <Card.Title className="mr-3">
                Adjectives:
                <Button
                  className="yellow"
                  onClick={this.fetchAdjectives}
                  style={{ marginLeft: "30%", width: "3rem" }}
                >
                  <img
                    src={shuffleIcon}
                    alt="Refresh"
                    style={{ height: "100%", width: "100%" }}
                  />
                </Button>
              </Card.Title>
            </Row>
            <Row className="text-left">
              <Col className="mb-3">{suggestionAdjectives}</Col>
            </Row>
          </Container>
        </Card.Body>
      </Card>
    );
  }
}

export default PromptSuggestions;
